<template lang="pug">
#drawer-inspecionar-camadas
    el-drawer.font-component(
        :title='$t("mensagens.menuSig.inspecionarCamadas")',
        direction='rtl',
        :class='menuMaior ? "drawer-inspecionar-camadas" : "drawer-inspecionar-camadas menor"',
        :visible.sync='show',
        :before-close='fechar',
        :wrapperClosable='false',
        :modal='false',
        :lock-scroll='true',
        :append-to-body='false',
        :close-on-press-escape='true',
        :size='menuMaior ? 360 : 247',
        :show-close='true'
    )
        span.ml-3 {{ localidades }}

        Diagnostico.m-3(:dadosConsulta='resultados', :inspecionar='true')
</template>

<script>
import Diagnostico from '@/components/diagnosticoSocioambiental/index';
import { CamadasService } from '@/services/CamadasService.js';

export default {
    name: 'DrawerInspecionarCamadas',
    components: {
        Diagnostico
    },

    props: {
        show: {
            type: Boolean,
            required: false,
            default: false
        },
        geometria: {
            type: Object,
            required: true
        },
        menuMaior: {
            type: Boolean,
            required: false,
            default: false
        },
        camadas: {
            type: Array,
            required: true
        }
    },

    data() {
        return {
            resultados: {},
            localidade_nivel_1: undefined,
            localidade_nivel_2: undefined,
            car: undefined,
            departamento: true
        };
    },

    computed: {
        localidades() {
            const getProperty = (item, keys) =>
                keys.map(key => item?.properties?.[key]).find(value => value);

            let localidades = '';

            if (this.localidade_nivel_2?.resultados?.[0]) {
                localidades = getProperty(
                    this.localidade_nivel_2.resultados[0],
                    ['nome', 'dist_desc']
                );

                if (this.localidade_nivel_1?.resultados?.[0]) {
                    localidades += ` - ${getProperty(
                        this.localidade_nivel_1.resultados[0],
                        ['sigla', 'dpto_desc']
                    )}`;
                }
            } else if (this.localidade_nivel_1?.resultados?.[0]) {
                localidades = getProperty(
                    this.localidade_nivel_1.resultados[0],
                    ['nome', 'dpto_desc']
                );
            }

            return localidades || '';
        },

        codigoCar() {
            const carCode = this.car?.resultados?.[0]?.properties?.codigo;
            return carCode ? `CAR: ${carCode}` : '';
        }
    },

    watch: {
        show: function () {
            if (this.show) {
                this.inspecionarCamadas();
            }
        }
    },

    methods: {
        fechar() {
            this.$emit('fechar');
        },

        inspecionarCamadas() {
            CamadasService.inspecionarCamadas(
                this.camadas,
                JSON.stringify(this.geometria)
            )
                .then(({ data }) => {
                    const nivel1Codes =
                        this.camadasAdministrativasLocalidadeNivel1();
                    const nivel2Codes =
                        this.camadasAdministrativasLocalidadeNivel2();

                    this.resultados = {
                        diagnosticos: data.filter(
                            ({ camada }) =>
                                !nivel1Codes.includes(camada.codigo) &&
                                !nivel2Codes.includes(camada.codigo)
                        )
                    };

                    this.localidade_nivel_1 = data.find(({ camada }) =>
                        nivel1Codes.includes(camada.codigo)
                    );

                    this.localidade_nivel_2 = data.find(({ camada }) =>
                        nivel2Codes.includes(camada.codigo)
                    );
                })
                .catch(() => {
                    this.$notify.error({
                        message: this.$t('mensagens.menuSig.errorDrawerCamadas')
                    });
                });
        },

        camadasAdministrativasLocalidadeNivel1() {
            return [
                'BR_LOCALIDADE_NIVEL_1',
                'PY_LOCALIDADE_NIVEL_1',
                'AR_LOCALIDADE_NIVEL_1'
            ];
        },
        camadasAdministrativasLocalidadeNivel2() {
            return [
                'BR_LOCALIDADE_NIVEL_2',
                'PY_LOCALIDADE_NIVEL_2',
                'AR_LOCALIDADE_NIVEL_2'
            ];
        }
    }
};
</script>

<style lang="scss">
#drawer-inspecionar-camadas {
    font-family: 'Roboto', 'sans serif';
    .el-drawer.rtl {
        border-radius: 0 3px 3px 0;
    }

    .drawer-inspecionar-camadas {
        position: absolute;

        .el-input--prefix .el-input__inner {
            padding-left: 35px;
        }

        #el-drawer__title > button > i {
            &::before {
                color: #3b3b3b;
                font-weight: 600;
                font-size: 16px;
            }
        }

        #el-drawer__title
            > div.w-100.el-input.el-input--prefix
            > .el-input__prefix {
            top: 10px;
            left: 10px;
            color: var(--primary) !important;
            i {
                font-size: 20px;
            }
        }

        #el-drawer__title
            > div.w-100.el-input.el-input--suffix
            > .el-input__suffix {
            color: var(--primary) !important;
            i {
                font-size: 20px;
            }
        }
    }

    .drawer-inspecionar-camadas.menor {
        .el-input--prefix .el-input__inner {
            padding-left: 35px;
        }

        #el-drawer__title > button > i {
            &::before {
                color: #3b3b3b;
                font-weight: 600;
                font-size: 14px;
            }
        }

        #el-drawer__title > div.w-100.el-input.el-input--prefix > span {
            top: 10px;
            left: 10px;
            color: var(--primary) !important;
            i {
                font-size: 20px;
            }
        }

        #el-drawer__title
            > div.w-100.el-input.el-input--suffix
            > .el-input__suffix {
            color: var(--primary) !important;
            i {
                font-size: 20px;
            }
        }
    }
}
.el-drawer__body {
    @include scroll-bar();
}

.font-component {
    font-size: 18px;
}
</style>
